import classNames from "classnames";
import FileSaver from "file-saver";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { toast, ToastContainer } from "react-toastify";
import { Breadcrumb, BreadcrumbItem, Button, Card, CardBody, CardFooter, CardHeader, Col, Input, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Pagination, Row, Spinner, TabContent, Table, TabPane } from "reactstrap";
import CustomerDashboardQuickLinks from "../../components/CustomerDashboard/CustomerDashboardQuickLinks";
import Paragraph from "../../components/tools/Paragraph";
import AttachmentService from "../../services/AttachmentService";
import SparePartService from "../../services/SparePartService";
import UserService from "../../services/UserService";

class SpareParts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            items: [],
            sparePartsData: {
                request: {
                    pageRequest: {
                        currentPage: 1,
                        pageSize: 50
                    },
                    sortRequest: {
                        key: "",
                        direction: false
                    },
                    filterRequest: {
                        sparePartGroupID: 0,
                        sparePartSubGroupID: 0,
                        prodCode: "",
                        description: "",
                    },
                },
                response: {
                    records: [],
                    totalRecords: 0,
                    currentPage: 1,
                    pageSize: 50
                },
            },
            user: {},
            sparePartGroups: [],
            sparePartSubGroups: [],
            priceVisibility: {},
            showImageModal: false,
            activeImageIndex: 0,
            highQualityImages: [],
            animating: false,
            downloading: false,
        };
        this.SparePartService = new SparePartService();
        this.userService = new UserService();
        this.attachmentService = new AttachmentService();
    }

    componentDidMount() {
        let { sparePartsData } = this.state;
        let user = this.userService.getLoggedInUser();
        this.setState({ user });
        this.getSparePartGroups().then(() => {
            this.toggleGroup(this.state.sparePartGroups.length > 0 ? this.state.sparePartGroups[0].id : 0);
        });
    }

    getSpareParts = (sparePartsData) => {
        this.setState({ loading: true });
        this.SparePartService.listSpareParts(sparePartsData.request)
            .then(res => {
                sparePartsData.response = res.data;
                this.setState({ items: res.data.records, loading: false, sparePartsData: sparePartsData });
            })
            .catch(() => this.setState({ loading: false }));
    };

    getSparePartGroups = () => {
        return this.SparePartService.listGroups({
            pageRequest: {
                currentPage: 0,
                pageSize: 0
            },
            sortRequest: {
                key: "",
                direction: false
            },
            filterRequest: {
                name: "",
                groupID: 0,
            },
        })
            .then(res => {
                this.setState({ sparePartGroups: res.data.records || [] });
            })
            .catch(() => { });
    };

    getSparePartsubGroups = (groupID) => {
        this.SparePartService.listSubGroups({
            pageRequest: {
                currentPage: 0,
                pageSize: 0
            },
            sortRequest: {
                key: "",
                direction: false
            },
            filterRequest: {
                name: "",
                groupID: groupID,
            },
        })
            .then(res => {
                this.setState({ sparePartSubGroups: res.data.records || [] });
            })
            .catch(() => { });
    };

    handleChange(change, key) {
        let { sparePartsData } = this.state;
        switch (key) {
            case "searchText":
                this.setState({ searchText: change });
                break;
            case "sortKey":
                if (sparePartsData.request.sortRequest.key === change) {
                    sparePartsData.request.sortRequest.direction = !sparePartsData.request.sortRequest.direction;
                } else {
                    sparePartsData.request.sortRequest.key = change;
                    sparePartsData.request.sortRequest.direction = false;
                }
                if (!(change === "action" || change === "srNo" || change === "status")) {
                    this.getSpareParts(sparePartsData);
                }
                break;
            case "pageSize":
                sparePartsData.request.pageRequest[key] = change;
                sparePartsData.request.pageRequest.currentPage = 1;
                this.getSpareParts(sparePartsData);
                break;
            case "currentPage":
                sparePartsData.request.pageRequest[key] = change;
                this.getSpareParts(sparePartsData);
                break;

            default:
                sparePartsData.request.filterRequest[key] = change;
                sparePartsData.request.pageRequest.currentPage = 1;
                this.getSpareParts(sparePartsData);
        }
    }

    getSparePartsHeading({ filterRequest }) {
        let { user } = this.state;
        let usersHeading = [
            {
                key: "srNo",
                label: "Sr. No",
                type: "text",
                colSpan: 1,
                width: '100px',
                sorterApplicable: false,
                valueClassName: "text-center align-middle",
                labelClassName: "text-center align-middle",
                searchNodeColSpan: 1,
                searchNode: null,
                showColumn: true,
            },
            {
                key: "thumbnailImageAttachment",
                label: "Thumbnail",
                type: "image",
                colSpan: 1,
                width: '150px',
                sorterApplicable: false,
                valueClassName: "text-center align-middle",
                labelClassName: "text-center align-middle",
                searchNodeColSpan: 1,
                searchNode: null,
                showColumn: true,
            },
            {
                key: "offRangeCode",
                label: "Off Range Code",
                type: "text",
                colSpan: 1,
                width: '350px',
                sorterApplicable: true,
                valueClassName: "text-center align-middle",
                labelClassName: "text-center align-middle",
                searchNodeColSpan: 1,
                searchNode: <div>
                    <Input type="search" id="offRangeCode" name="offRangeCode"
                        value={filterRequest.offRangeCode}
                        onChange={(e) => this.handleChange(e.target.value, "offRangeCode")}
                        placeholder="Search..." />
                </div>,
                showColumn: true,
            },
            {
                key: "description",
                label: "Description",
                type: "text",
                colSpan: 1,
                width: '700px',
                sorterApplicable: true,
                valueClassName: "",
                labelClassName: "hoverableItem text-center align-middle",
                searchNodeColSpan: 1,
                searchNode: <div><Input type="search" id="description" name="description"
                    value={filterRequest.description}
                    onChange={(e) => this.handleChange(e.target.value, "description")}
                    placeholder="Search..." /></div>,
                showColumn: true,
            },
            {
                key: "price",
                label: "Cost Price (Ex GST)",
                type: "decimal",
                colSpan: 1,
                width: '250px',
                sorterApplicable: false,
                valueClassName: "text-center align-middle",
                labelClassName: "text-center align-middle",
                searchNodeColSpan: 1,
                searchNode: null,
                showColumn: true,
            },
            {
                key: "action",
                label: "Action",
                type: "action",
                colSpan: 1,
                width: '200px',
                sorterApplicable: false,
                valueClassName: "text-center align-middle",
                labelClassName: "text-center align-middle",
                searchNodeColSpan: 1,
                searchNode: <div className="text-center align-middle"><Link className="btn btn-primary btn-sm"
                    to={{ pathname: "/sparepart/details", state: { selectedGroup: filterRequest.sparePartGroupID } }}><i
                        className="fa fa-plus" />&nbsp;
                    Add </Link></div>
                ,
                showColumn: user && user.menu && user.menu.role === 'ExternalUser' ? false : true,
            }];

        return usersHeading;
    }

    toggleGroup(id) {
        if (this.state.sparePartsData.request.filterRequest.sparePartGroupID !== id) {
            let { sparePartsData } = this.state;
            sparePartsData.request.filterRequest.sparePartGroupID = id;
            sparePartsData.request.filterRequest.sparePartSubGroupID = 0;
            sparePartsData.request.pageRequest.currentPage = 1;
            this.setState({
                sparePartsData: sparePartsData,
            }, () => {
                this.getSpareParts(this.state.sparePartsData);
                this.getSparePartsubGroups(id);
            });
        }
    }

    toggleSubGroup(id) {
        if (this.state.sparePartsData.request.filterRequest.sparePartSubGroupID !== id) {
            let { sparePartsData } = this.state;
            sparePartsData.request.filterRequest.sparePartSubGroupID = id;
            sparePartsData.request.pageRequest.currentPage = 1;
            this.setState({
                sparePartsData: sparePartsData,
            }, () => {
                this.getSpareParts(this.state.sparePartsData);
            });
        }
    }

    togglePrice = (prodCode) => {
        this.setState(prev => ({
            priceVisibility: {
                ...prev.priceVisibility,
                [prodCode]: !prev.priceVisibility[prodCode]
            }
        }));
    };

    handleDelete = () => {
        const { deleteGroupId } = this.state;
        this.SparePartService.deleteSparePart(deleteGroupId)
            .then(() => {
                toast.success("Deleted");
                this.getSpareParts(this.state.sparePartsData);
                this.cancelDelete();
            })
            .catch(() => toast.error("Delete failed"));
    };

    confirmDelete = (id) => {
        this.setState({ showDeleteModal: true, deleteGroupId: id });
    };

    cancelDelete = () => {
        this.setState({ showDeleteModal: false, deleteGroupId: null });
    };

    openImageModal = (images, index = 0) => {
        this.setState({
            showImageModal: true,
            activeImageIndex: index,
            highQualityImages: images || []
        });
    };

    closeImageModal = () => {
        this.setState({ showImageModal: false });
    };

    handleImageDownload = (item) => {
        if (!item || this.state.downloading) return;

        this.setState({ downloading: true });

        this.attachmentService
            .downloadAttachment(item.id)
            .then(response => {
                FileSaver.saveAs(response.data, item.description);
            })
            .catch(error => {
                toast.error(handleErrorMessage(error), {
                    position: toast.POSITION.BOTTOM_CENTER
                });
                console.error(error);
            })
            .finally(() => {
                this.setState({ downloading: false });
            });
    };

    render() {
        const { loading, sparePartsData, user, sparePartGroups, sparePartSubGroups, priceVisibility, downloading } = this.state;
        const { sortRequest, pageRequest, filterRequest } = sparePartsData.request;
        let userHeading = this.getSparePartsHeading(sparePartsData.request);
        const activeImage =
            this.state.highQualityImages[this.state.activeImageIndex];
        return (
            <div>

                <div className="text-center">
                    {user && user.menu && user.menu.role === 'ExternalUser' ?
                        <CustomerDashboardQuickLinks size={"sm"} /> : <Breadcrumb tag="nav" listTag="div">
                            <BreadcrumbItem tag="a" href="javascript:void(0)"
                                onClick={() => this.props.history.push('/')}>Home</BreadcrumbItem>
                            <BreadcrumbItem active tag="span">Spare Parts</BreadcrumbItem>
                        </Breadcrumb>}
                    <hr />
                </div>
                <Card>
                    <CardHeader>
                        <Nav tabs card>
                            {sparePartGroups.map((group, index) =>
                                <NavItem className={"hoverableItem"} key={group.id}>
                                    <NavLink
                                        className={classNames({ active: sparePartsData.request.filterRequest.sparePartGroupID === group.id })}
                                        onClick={() => {
                                            this.toggleGroup(group.id);
                                        }}>
                                        <Button
                                            size="sm"
                                            color={"link"}>
                                            <h5>
                                                {group.name}
                                            </h5>
                                        </Button>
                                    </NavLink>
                                </NavItem>
                            )}
                        </Nav>
                        {sparePartsData.request.filterRequest.sparePartGroupID !== 0 && (
                            <Nav tabs card>
                                <NavItem className={"hoverableItem mt-2"}>
                                    <NavLink
                                        className={classNames({ active: sparePartsData.request.filterRequest.sparePartSubGroupID === 0 })}
                                        onClick={() => this.toggleSubGroup(0)}
                                    >
                                        <Button style={{ textDecoration: "none" }}
                                            size={"sm"}
                                            color={"link"}>All&nbsp;
                                        </Button>
                                    </NavLink>
                                </NavItem>

                                {sparePartSubGroups
                                    .map(sg =>
                                        <NavItem className={"hoverableItem mt-2"} key={sg.id}>
                                            <NavLink
                                                className={classNames({ active: sparePartsData.request.filterRequest.sparePartSubGroupID === sg.id })}
                                                onClick={() => this.toggleSubGroup(sg.id)}
                                            >
                                                <Button style={{ textDecoration: "none" }}
                                                    size={"sm"}
                                                    color={"link"}>{sg.name}
                                                    &nbsp;
                                                </Button>
                                            </NavLink>
                                        </NavItem>
                                    )}
                            </Nav>
                        )}
                    </CardHeader>
                    <CardBody>
                        <TabContent activeTab={sparePartsData.request.filterRequest.sparePartGroupID}>
                            {sparePartGroups.map((group) => (
                                <TabPane tabId={group.id} key={group.id}>
                                    <Row>
                                        <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                                            <div className={"text-left"}>
                                                {
                                                    loading
                                                        ? <Spinner size="sm" color={"primary"} />
                                                        : <span>
                                                            Showing
                                                            {' '}{((pageRequest.currentPage - 1) * pageRequest.pageSize) + 1}
                                                            {' '}to {((pageRequest.currentPage) * pageRequest.pageSize)}
                                                            {' '}of {sparePartsData.response.totalRecords}
                                                            {' '}entries

                                                        </span>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                    <div>
                                        <Table striped bordered responsive hover size='md'>
                                            <thead>
                                                <tr>
                                                    {(userHeading || []).filter(item => item.showColumn).map((item, index) => {
                                                        return (
                                                            <th key={index}
                                                                onClick={() => this.handleChange(item.key, "sortKey")}
                                                                colSpan={item.colSpan}
                                                                className={item.labelClassName}
                                                                style={{ minWidth: item.minWidth, width: item.width, cursor: item.sorterApplicable ? "pointer" : "default" }}>
                                                                {item.label}
                                                                {
                                                                    item.sorterApplicable ?
                                                                        <i className={classNames("fa", "float-right", "pt-1", {
                                                                            "fa-sort": (sortRequest.key !== item.key),
                                                                            "fa-sort-amount-asc": (sortRequest.key === item.key && sortRequest.direction),
                                                                            "fa-sort-amount-desc": (sortRequest.key === item.key && !sortRequest.direction),
                                                                        }
                                                                        )} aria-hidden="true" /> : null
                                                                }

                                                            </th>
                                                        );
                                                    })}
                                                </tr>
                                                <tr>
                                                    {(userHeading || []).filter(item => item.showColumn).map((item, index) => {
                                                        if (item.searchNodeColSpan > 0) {
                                                            return (
                                                                <td key={index} colSpan={item.searchNodeColSpan}
                                                                    className={"align-middle"}>
                                                                    {item.searchNode}
                                                                </td>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </tr>

                                            </thead>

                                            <tbody>
                                                {(sparePartsData.response.records || []).map((sparePart, index) =>

                                                    <tr key={sparePart.prodCode}>
                                                        <td className="text-center align-middle">{((pageRequest.currentPage - 1) * pageRequest.pageSize) + (index + 1)}</td>
                                                        <td className="text-center align-middle">
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    height: "100%"
                                                                }}
                                                            >
                                                                {sparePart.thumbnailImageAttachment?.[0]?.publicUrl && (
                                                                    <Button
                                                                        color="link"
                                                                        onClick={() =>
                                                                            this.openImageModal(
                                                                                sparePart.highQualityImageAttachment || [],
                                                                                0
                                                                            )
                                                                        }>
                                                                        <img
                                                                            title="Enlarge"
                                                                            src={sparePart.thumbnailImageAttachment[0].publicUrl}
                                                                            style={{
                                                                                width: "150px",
                                                                                height: "100px",
                                                                                objectFit: "cover",
                                                                                border: "none"
                                                                            }}
                                                                        />
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <div>
                                                                <Paragraph
                                                                    text={sparePart.offRangeCode}
                                                                    copyText={sparePart.offRangeCode}
                                                                    isCopyable
                                                                    innerTag="strong"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className="align-middle"><Paragraph
                                                            text={sparePart.description}
                                                            copyText={sparePart.description}
                                                            isCopyable
                                                            innerTag="span"
                                                        /></td>
                                                        <td className="text-center align-middle">{user && user.menu && user.menu.role === 'ExternalUser' ?
                                                            <div style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                width: "100%",
                                                                marginRight: "8px",
                                                                justifyContent: "center",
                                                            }}>
                                                                <Paragraph
                                                                    text={priceVisibility[sparePart.offRangeCode]
                                                                        ? `$${Number(sparePart.price).toFixed(2)}`
                                                                        : "••••••"}
                                                                    copyText={`${Number(sparePart.price).toFixed(2)}`}
                                                                    isCopyable
                                                                    innerTag="span"
                                                                />
                                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                    <Button
                                                                        color="link"
                                                                        size="sm"
                                                                        className="p-0 ml-2"
                                                                        onClick={() => this.togglePrice(sparePart.offRangeCode)}
                                                                        title="Toggle price visibility"
                                                                    >
                                                                        <i
                                                                            className={`fa ${this.state.priceVisibility[sparePart.offRangeCode] ? "fa-eye-slash" : "fa-eye"}`}
                                                                            style={{ fontSize: "18px" }}   // bigger icon
                                                                        />
                                                                    </Button>
                                                                </div>
                                                            </div> : `$${sparePart.price.toFixed(2)}`}
                                                        </td>
                                                        {user && user.menu && user.menu.role === 'ExternalUser' ? null :
                                                            <td className="text-center align-middle"><Link
                                                                className="btn btn-sm btn-primary"
                                                                to={{
                                                                    pathname: "/sparepart/details",
                                                                    state: { sparePart }
                                                                }}> <i className="fa fa-pencil mr-2"
                                                                    aria-hidden="true" />Edit</Link><span>&nbsp;&nbsp;</span>
                                                                <Button
                                                                    color="danger"
                                                                    size="sm"
                                                                    onClick={() => this.confirmDelete(sparePart.offRangeCode)}
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </Button>
                                                            </td>}
                                                    </tr>
                                                )}

                                            </tbody>
                                        </Table>
                                    </div>
                                </TabPane>
                            ))}
                        </TabContent>

                    </CardBody>
                    <CardFooter>
                        <Row>
                            <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                                <div className={"text-left"} style={{ maxWidth: 200 }}>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Show</InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            type={"select"}
                                            name={"pageSize"}
                                            value={pageRequest.pageSize}
                                            disabled={loading}
                                            onChange={(e) => this.handleChange(e.target.value, "pageSize")}>
                                            <option value={10}>10 Rows</option>
                                            <option value={25}>25 Rows</option>
                                            <option value={50}>50 Rows</option>
                                            <option value={100}>100 Rows</option>
                                            <option value={500}>500 Rows</option>
                                        </Input>
                                    </InputGroup>


                                </div>
                            </Col>
                            <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                                <div className={"float-right"}>
                                    <Pagination
                                        activePage={pageRequest.currentPage}
                                        itemsCountPerPage={pageRequest.pageSize}
                                        totalItemsCount={sparePartsData.response.totalRecords}
                                        pageRangeDisplayed={3}
                                        onChange={(activePage) => this.handleChange(activePage, "currentPage")}
                                        itemClass='page-item'
                                        linkClass='page-link'
                                        activeClass='active'
                                        innerClass='pagination'
                                        activeLinkClass='active'
                                    />
                                </div>

                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
                <ToastContainer />
                <Modal isOpen={this.state.showDeleteModal} toggle={this.cancelDelete}>
                    <ModalHeader toggle={this.cancelDelete}>Confirm Delete</ModalHeader>
                    <ModalBody>Are you sure you want to delete this spare part ?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.handleDelete}>Delete</Button>
                        <Button color="secondary" onClick={this.cancelDelete}>Cancel</Button>
                    </ModalFooter>
                </Modal>

                <Modal
                    isOpen={this.state.showImageModal}
                    toggle={this.closeImageModal}
                    centered
                    style={{ maxWidth: '900px', width: '100%' }} // max-w-3xl w-full
                >
                    <ModalHeader toggle={this.closeImageModal}>{this.state.highQualityImages[this.state.activeImageIndex]?.description || 'Image'}</ModalHeader>

                    <ModalBody
                        style={{
                            height: '600px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            backgroundColor: '#f3f4f6' // bg-gray-100
                        }}
                    >
                        {this.state.highQualityImages.length === 0 ? (
                            <p style={{ textAlign: 'center', width: '100%' }}>No images available</p>
                        ) : (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <div
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >
                                    <img
                                        src={this.state.highQualityImages[this.state.activeImageIndex].publicUrl}
                                        alt=""
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '600px',
                                            objectFit: 'contain'
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button disabled={!activeImage || downloading} color="primary" onClick={() => { this.handleImageDownload(activeImage) }}>{this.state.downloading ? 'Downloading…' : 'Download'}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default SpareParts;
